
import React from "react";
import "../../Css/FiveCard.css";

import centralized_booking_dashboard from '../../assets/booking_dashboard.webp';
import real_time_tracking from '../../assets/real_time_tracking.webp';
import recurring_deliveries from '../../assets/food-delivery-packky.jpeg';
import smart_billing_wallet from '../../assets/smart_billing_wallet.webp';
import wide_range_of_vehicles from '../../assets/wide_range_of_vehicles.webp';

const KeyFeatures = () => {
  return (
    <section className="relative z-10 py-10 sm:py-12 lg:py-14">
      <div className="mx-auto w-full max-w-[1100px] px-4 sm:px-5 lg:px-6">
        <h2 className="mb-8 text-center text-[22px] font-semibold sm:mb-10 sm:text-[24px] lg:text-[28px] text-[#212529]">
          Key Features We Offer
        </h2>

        <div className="grid grid-cols-12 gap-5">

          {/* Card 1 - Recurring Deliveries */}
          <div className="col-span-12 sm:col-span-6 lg:col-span-4">
            <div
              className="flex flex-col overflow-hidden rounded-[28px]"
              style={{ background:"#f7f7f7", minHeight: "260px" }}
            >
              <h3 className="mt-4 px-4 text-[18px] font-bold text-[#212529]">
                Recurring deliveries
              </h3>
              <div className="flex flex-1 items-end justify-start overflow-hidden">
                <img
                  src={recurring_deliveries}
                  alt="Recurring deliveries"
                 className="w-full max-h-[220px] object-contain object-left object-bottom"
                />
              </div>
            </div>
          </div>

          {/* Card 2 - Centralized Booking Dashboard */}
          <div className="col-span-12 sm:col-span-6 lg:col-span-4">
            <div
              className="flex flex-col overflow-hidden rounded-[28px]"
              style={{ background: "linear-gradient(180deg, #fcede2, #f8c275)", minHeight: "260px" }}
            >
              <h3 className="mt-4 mb-3 px-4 text-[18px] font-bold text-[#212529]">
                Centralized Booking Dashboard
              </h3>
              <div className="flex flex-1 items-end justify-end overflow-hidden">
                <img
                  src={centralized_booking_dashboard}
                  alt="Centralized Booking Dashboard"
                  className="w-full max-h-[210px] object-contain object-right-bottom"
                />
              </div>
            </div>
          </div>

          {/* Card 3 - Real-Time Tracking */}
          <div className="col-span-12 sm:col-span-6 lg:col-span-4">
            <div
              className="flex flex-col overflow-hidden rounded-[28px]"
              style={{ background: "#e0fbcf", minHeight: "260px" }}
            >
              <h3 className="mt-4 mb-3 px-4 text-[18px] font-bold text-[#212529]">
                Real-Time Tracking
              </h3>
              <div className="flex flex-1 items-end justify-center overflow-hidden">
                <img
                  src={real_time_tracking}
                  alt="Real-Time Tracking"
                  className="w-[85%] max-h-[200px] object-contain object-bottom"
                />
              </div>
            </div>
          </div>

          {/* Card 4 - Smart Billing & Wallet */}
          <div className="col-span-12 sm:col-span-6 lg:col-span-4">
            <div
              className="flex flex-col overflow-hidden rounded-[28px]"
              style={{ background: "linear-gradient(180deg, #F5FBFD, #ace5fb)", minHeight: "260px" }}
            >
              <h3 className="mt-4 mb-3 px-4 text-[18px] font-bold text-[#212529] max-w-[65%]">
                Smart Billing & Wallet
              </h3>
              <div className="flex flex-1 items-end justify-center overflow-hidden">
                <img
                  src={smart_billing_wallet}
                  alt="Smart Billing & Wallet"
                  className="max-h-[180px] w-[80%] object-contain rounded-3xl"
                />
              </div>
            </div>
          </div>

          {/* Card 5 - Wide Range Of Vehicles */}
          <div className="col-span-12 sm:col-span-12 lg:col-span-8">
            <div
              className="flex flex-col overflow-hidden rounded-[28px]"
              style={{ background: "linear-gradient(180deg, #f4ebfd, #bda8f9)", minHeight: "260px" }}
            >
              <h3 className="mt-4 mb-3 px-4 text-[18px] font-bold text-[#212529]">
                Wide Range Of Vehicles
              </h3>
              <div className="flex flex-1 items-end justify-end overflow-hidden">
  <img
    src={wide_range_of_vehicles}
    alt="Wide Range Of Vehicles"
    className="w-[105%] max-h-[210px] object-contain object-bottom lg:translate-x-20"
  />
</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;